import { Spinner } from '@ps/isp-web-component-library';
import { Size } from '@ps/web-core-store';
import { Translation } from '@ps/web-shared-components';
import classNames from 'clsx';
import React, { useContext, useEffect } from 'react';
import BodyClassName from 'react-body-classname';
import { useIntl } from 'react-intl';

import type { ModalContextValue } from '@swf/components/StarsModal/Context';
import { ModalContext } from '@swf/components/StarsModal/Context';
import Body from '@swf/components/StarsModal/components/Body';
import Header from '@swf/components/StarsModal/components/Header/Header';

import {
  TXTWCL_Placing_your_bet,
  TXTWCL_Please_wait_while_we_validate__ELL
} from './BetDelay.messages.json';
import styles from './BetDelay.scss';

const BetDelay: React.FC = () => {
  const { setStyle } = useContext<ModalContextValue>(ModalContext);
  const { formatMessage } = useIntl();

  useEffect(
    () =>
      setStyle({
        size: Size.EXTRA_SMALL,
        className: styles.modal,
        overlayClassName: styles.overlay
      }),
    [setStyle]
  );

  return (
    <section>
      <BodyClassName className={classNames(styles.rootDisplayBlock, styles.bodyOpen)} />
      <Body className={styles.body}>
        <Header className={styles.header}>
          <Translation {...TXTWCL_Placing_your_bet} />
        </Header>
        <Spinner aria-label={formatMessage(TXTWCL_Please_wait_while_we_validate__ELL)} />
        <Translation {...TXTWCL_Please_wait_while_we_validate__ELL} />
      </Body>
    </section>
  );
};

export default BetDelay;
